export default __webpack_public_path__ + "static/media/Team-Profile-Generator-img-1.ef3697e2.jpg";